import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';
import { Template } from '../../models/template';
import { TemplateStoreService } from '../services/template-store.service';

@Injectable()
export class TemplatesResolver implements Resolve<Template[]> {
    constructor(private templateStore: TemplateStoreService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Template[]> {
        return this.templateStore.getTemplates().pipe(
            tap((templates) => {
                if (templates.length <= 1) {
                    this.templateStore.fetchTemplates();
                }
            }),
            first()
        );
    }
}
